// TEMPORARY boot-sequence trace for the double-loader bug. Remove once diagnosed.
import { useEffect } from 'react';
import { useAuthStore } from '@clarix/auth-store';

const t0 = performance.now();

export function bootLog(...args: unknown[]): void {
  console.info(`[boot] +${Math.round(performance.now() - t0)}ms`, ...args);
}

export function useBootTrace(name: string, detail?: unknown): void {
  useEffect(() => {
    bootLog(`MOUNT   ${name}`);
    return () => bootLog(`UNMOUNT ${name}`);
  }, [name]);
  useEffect(() => {
    if (detail !== undefined) bootLog(`STATE   ${name}`, detail);
  }, [name, JSON.stringify(detail)]); // eslint-disable-line react-hooks/exhaustive-deps
}

if (typeof window !== 'undefined') {
  bootLog('DOCUMENT start', location.href);
  window.addEventListener('beforeunload', () => bootLog('DOCUMENT unload/reload'));
}

useAuthStore.subscribe((s, p) => {
  if (s.token !== p.token || s.workspaceSlug !== p.workspaceSlug) {
    bootLog('AUTH changed', { tokenChanged: s.token !== p.token, slug: `${p.workspaceSlug} → ${s.workspaceSlug}` });
  }
});
